import React from 'react';
import PropTypes from 'prop-types';
import {RecommendedPropertiesCarousel} from '@homeaway/react-property-carousel';
import translate from '../../../utils/translations';
import {recoCarousalBreakpoints} from '../../../utils/appConfigData';

export const RecommendationCarousel = ({data, location, translations}) => {
    const carouselTranslations =
        translations?.['traveler/react-property-carousel']?.messages;
    const subheading = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.cancellation.refund.confirm.recommended.caption'
    );
    const title = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.cancellation.refund.confirm.recommended.title',
        {location}
    );
    const target = 'STAY_SIMILAR_PROPERTY';

    return (
        <RecommendedPropertiesCarousel
            breakpoints={recoCarousalBreakpoints}
            data={data}
            isLoading={false}
            propertyViewEventFirePosition="onload"
            scrolling
            subheading={subheading}
            target={target}
            title={title}
            translations={carouselTranslations}
        />
    );
};

RecommendationCarousel.propTypes = {
    data: PropTypes.shape({
        recommendedListings: PropTypes.arrayOf(
            PropTypes.shape({
                listing: PropTypes.shape({
                    address: PropTypes.shape({
                        city: PropTypes.string,
                        country: PropTypes.string,
                        stateProvince: PropTypes.string,
                    }),
                    averagePrice: PropTypes.shape({
                        localized: PropTypes.string,
                    }),
                    averagePriceSummary: PropTypes.shape({
                        pricePeriodDescription: PropTypes.string,
                        formattedAmount: PropTypes.string,
                    }),
                    averageRating: PropTypes.number,
                    bathrooms: PropTypes.shape({
                        full: PropTypes.number,
                    }),
                    bedrooms: PropTypes.number,
                    detailPageUrl: PropTypes.string,
                    headlinePhotoUrl: PropTypes.string,
                    instantBookable: PropTypes.bool,
                    listingId: PropTypes.string,
                    propertyMetadata: PropTypes.shape({
                        headline: PropTypes.string,
                    }),
                    reviewCount: PropTypes.number,
                    sleeps: PropTypes.number,
                    spu: PropTypes.string,
                    thumbnailUrl: PropTypes.string,
                    totalPrice: PropTypes.shape({
                        localized: PropTypes.string,
                    }),
                }),
            })
        ),
        clientRequestId: PropTypes.string.isRequired,
    }),
    location: PropTypes.string,
};
